import { type IResourceApiContext, type BaseRequestOptions } from '../resources/common'
import qs from 'qs'
import type { CustomParamsSerializer, AxiosResponse } from 'axios'
import createTemplate from 'nano-var-template'

const engine = createTemplate({ start: '{', end: '}' })

const qsSerializer: CustomParamsSerializer = p => qs.stringify(p)

export function setPathParams (template: string, params?: Record<string, any>) {
  if (params == null) return template
  return engine(template, params)
}

export function setCurrentUserPath (currentUser: boolean, path: string) {
  return currentUser ? `/currentuser/${path}` : path
}

export async function createApiRequest (config: {
  ctx: IResourceApiContext
  method: string
  path: string
  query?: any
  data?: any
  options?: BaseRequestOptions
}): Promise<AxiosResponse> {
  const { ctx, options, query, path, method, data } = config
  const authToken = options?.userAuthToken ?? ctx.options.userAuthToken
  const tenant = options?.tenant ?? ctx.options.tenant
  return await ctx.apiClient.request({
    url: path,
    method,
    params: query,
    data,
    ...(options?.qs != null && { paramsSerializer: { serialize: qsSerializer } }),
    headers: {
      'Content-Type': 'application/json',
      ...(options?.disableAuth !== true && authToken != null && { Authorization: `Bearer ${authToken}` }),
      ...(options?.disableAuth !== true && tenant != null && { 'source-tenant': tenant })
    }
  })
}
